import Vue from "vue";
import App from "./App.vue"; // import du Router global
import router from "./router/router"; // import du Router global
import store from "../config/store"; // import du gestionnaire d'état global
import VueMatomo from 'vue-matomo'

/**
 * IMPORT DES FILTRES
 */

import './filters/text';

/**
 * IMPORT DES LIBRAIRIES
 */
import Translate from './lib/Translate'
import Validator from './lib/Validator'
import ImageAlt from './lib/ImageAlt'
import DateFormatter from './lib/DateFormatter'

Vue.use(Translate, {store: store});
Vue.use(Validator)
Vue.use(ImageAlt)
Vue.use(DateFormatter)
/**
 * LAYOUTS
 */
import Blank from "./layouts/Blank"; // import du layout Blank
import Default from "./layouts/Default"; // import du layout Store
import Light from "./layouts/Light"; // import du layout Store

/**
 * STYLES
 */
import "./assets/css/reset.css"; // Remise à zéro des styles
import "./assets/css/helpers.css"; // classe d'aide css
import "./assets/css/typography.css"; // Styles pour les textes
import "./assets/css/main.css"; // Styles globaux
import "./assets/css/phones.css" // Fichier de responsive pour les téléphones
import "./assets/css/tablets.css" // Fichier de responsive pour les tablettes
import "./assets/css/laptops.css" // Fichier de responsive pour les écrans d'ordinateur (rétina / non rétina)
import "./assets/css/responsive.css" // Fichier de responsive global
import "./assets/css/colors.css" // Fichier des couleurs

import "./assets/css/google-material.css";

Vue.component("blank", Blank); // Déclaration du layout Blank comme composant
Vue.component("default", Default); // Déclaration du layout Store comme composant
Vue.component("light", Light); // Déclaration du layout Light comme composant

Vue.config.productionTip = process.env.VUE_APP_PROD;

var siteId = 2;

if(process.env.VUE_APP_PROD === "true") {
  siteId = 1;
}

Vue.use(VueMatomo, {
  host: 'https://stats.mysatab.com',
  siteId: siteId,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");